import { render, staticRenderFns } from "./ProductList3.vue?vue&type=template&id=054e8dbc&scoped=true&"
import script from "./ProductList3.vue?vue&type=script&lang=js&"
export * from "./ProductList3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e8dbc",
  null
  
)

export default component.exports